import { render } from "./formvalidation.vue?vue&type=template&id=35fb0cbe"
import script from "./formvalidation.vue?vue&type=script&lang=js"
export * from "./formvalidation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__